/*
Copyright 2022 Fondazione Bruno Kessler
Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
except in compliance with the Licence.

You may obtain a copy of the Licence at:
http://ec.europa.eu/idabc/eupl.html

Unless required by applicable law or agreed to in writing, software distributed under 
the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF 
ANY KIND, either express or implied. See the Licence for the specific language 
governing permissions and limitations under the Licence.
*/
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {AppEnvironmentConfig} from "@app/app.environment.config";
import {SaluteHelperService} from "@trec/api";

@Injectable()
export class AppLoadService {
  constructor(
    private http: HttpClient,
    private saluteHelper: SaluteHelperService,
  ) {}

  initializeHomeApp(): Promise<void> {
    return new Promise(async (resolve) => {
      var retrievedConfs: any;
      if (window.location.origin.indexOf("localhost") > -1) {
        retrievedConfs = await this.http.get("assets/configs/deda-config.json").toPromise();
      } else if (window.location.origin.indexOf("dedagroup.it") > -1) {
        retrievedConfs = await this.http.get("./assets/configs/deda-config.json").toPromise();
      } else if (window.location.origin.indexOf("asst-settelaghi.it") > -1) {
        retrievedConfs = await this.http.get("./assets/configs/7laghi-config.json").toPromise();
      } else if (window.location.origin.indexOf("websanity.it") > -1) {
        retrievedConfs = await this.http.get("./assets/configs/ragusa-config.json").toPromise();
      } else if (
        window.location.origin.indexOf("apss.tn.it") > -1 ||
        window.location.origin.indexOf("trec.trentinosalute.net") > -1
      ) {
        retrievedConfs = await this.http.get("./assets/configs/trec-config.json").toPromise();
      }

      if (retrievedConfs) {
        AppEnvironmentConfig.primaryColor = retrievedConfs.primaryColor;
        AppEnvironmentConfig.srcLogo = retrievedConfs.srcLogo;
        AppEnvironmentConfig.email = retrievedConfs.email;
        AppEnvironmentConfig.hasArruolati = retrievedConfs.hasArruolati;
        AppEnvironmentConfig.app = retrievedConfs.app;
        AppEnvironmentConfig.context = retrievedConfs.context;
      }

      // Load Configuration App into store
      let availableService = await this.saluteHelper.getConfiguratoreAppSync(
        AppEnvironmentConfig.context,
      );
      if (availableService) {
        localStorage.setItem("configuratoreChat", JSON.stringify(availableService.chat));
        localStorage.setItem("configuratoreReport", JSON.stringify(availableService.report));
        localStorage.setItem(
          "configuratoreTelevisita",
          JSON.stringify(availableService.televisita),
        );
        localStorage.setItem(
          "configuratoreTelemonitoraggio",
          JSON.stringify(availableService.telemonitoraggio),
        );
        localStorage.setItem(
          "configuratoreTeleconsulto",
          JSON.stringify(availableService.teleconsulto),
        );
        localStorage.setItem("siat-televisita", JSON.stringify(availableService.siat_segnalazione));
        localStorage.setItem(
          "configuratoreMultipaziente",
          JSON.stringify(availableService.multipaziente),
        );
        localStorage.setItem("configuratoreHD", JSON.stringify(availableService.hd));
        localStorage.setItem("configuratoreContext", JSON.stringify(availableService.context));
        localStorage.setItem(
          "configuratoreActivationCode",
          JSON.stringify(availableService.activationcode),
        );
        localStorage.setItem(
          "configuratoreAppointments",
          JSON.stringify(availableService.appointments),
        );
        localStorage.setItem("configuratoreError", JSON.stringify(null));
        localStorage.setItem(
          "configuratoreTelevisitaJoinTime",
          JSON.stringify(availableService.televisitajointime),
        );
        if (availableService.prescrizioneApp != undefined) {
          localStorage.setItem(
            "configuratorePrescrizioneApp",
            JSON.stringify(availableService.prescrizioneApp),
          );
        }
        localStorage.setItem("editAnagrafica", JSON.stringify(availableService.editAnagrafica));
        localStorage.setItem(
          "editProfiloSocioDemo",
          JSON.stringify(availableService.editProfiloSocioDemo),
        );
        localStorage.setItem("health-meeting", JSON.stringify(availableService["health-meeting"]));
        localStorage.setItem("configuratorePdta", JSON.stringify(availableService.pdta));
        //localStorage.setItem("questionnaires", JSON.stringify(availableService["questionnaires"] || true)); //Serve???
        localStorage.setItem("survey", JSON.stringify(availableService["survey"]));
        localStorage.setItem("mmg", JSON.stringify(availableService["mmg"]));
        // Only store assistant if present
        if (availableService.assistant !== undefined) {
          localStorage.setItem(
            "configuratoreAssistant",
            JSON.stringify(availableService.assistant),
          );
        }
      }
      resolve();
    });
  }
}
